{
  "page": {
    "title": "All employees"
  },
  "subtabs": {
    "label": "Employee sections",
    "all": "All employees"
  },
  "actions": {
    "add": "Add employee",
    "addAdmin": "Add reservoir admin",
    "addMenu": "Choose what to add",
    "search": "Search",
    "view": "View",
    "edit": "Edit",
    "permissions": "Permissions",
    "block": "Block",
    "unblock": "Unblock",
    "delete": "Delete",
    "rowMenu": "Actions"
  },
  "table": {
    "label": "Employees table",
    "employee": "Employee",
    "position": "Position",
    "phone": "Phone",
    "adminPanel": "Admin panel",
    "monitoringPanel": "Monitoring panel",
    "actions": "Actions",
    "total": "Total: {{count}}",
    "empty": "No employees",
    "emptyHint": "No employees have been added yet. Click “Add employee”.",
    "noResults": "Nothing found",
    "noResultsHint": "No employees match “{{q}}”.",
    "clear": "Clear",
    "loadError": "Could not load the data",
    "retry": "Retry",
    "pagination": {
      "previous": "Previous page",
      "next": "Next page"
    }
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "blocked": "Blocked"
  },
  "access": {
    "admin": {
      "full": "Full (CRUD)",
      "some": "Has access",
      "none": "No access"
    },
    "monitoring": {
      "full": "Full",
      "viewOnly": "View only",
      "none": "No access",
      "parts": {
        "view": "view",
        "edit": "edit",
        "delete": "delete",
        "upload": "files"
      }
    }
  },
  "form": {
    "addTitle": "Add employee",
    "addAdminTitle": "Add reservoir admin",
    "steps": {
      "label": "Steps",
      "general": "General info",
      "permissions": "Permissions",
      "done": "done",
      "current": "current step"
    },
    "avatar": {
      "upload": "Upload photo",
      "hint": "JPG or PNG, up to 2 MB",
      "uploading": "Uploading...",
      "remove": "Remove photo",
      "invalid": "JPG or PNG only, up to 2 MB",
      "failed": "Could not upload the photo"
    },
    "fullName": "Full name",
    "position": "Position",
    "phone": "Phone",
    "reservoir": "Reservoir",
    "login": "Login",
    "password": "Password",
    "role": "Role",
    "fullNamePlaceholder": "First Last",
    "positionPlaceholder": "e.g. Chief engineer",
    "phonePlaceholder": "+998 90 123 45 67",
    "loginPlaceholder": "first.last",
    "passwordUnchanged": "••••••••••",
    "passwordHint": "Saving a new password signs the employee out everywhere.",
    "reservoirLocked": "Only organization admins can choose another reservoir",
    "roles": {
      "tenant_member": "Employee",
      "tenant_admin": "Reservoir admin",
      "org_admin": "Organization admin",
      "platform_admin": "Main admin"
    },
    "active": "Active employee",
    "copy": "Copy",
    "copied": "Copied",
    "regenerateLogin": "Generate login",
    "regeneratePassword": "Generate password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "loginTaken": "This login is taken. Free option: {{suggestion}}",
    "useSuggestion": "Use {{suggestion}}",
    "continue": "Continue",
    "back": "Back",
    "save": "Save",
    "cancel": "Cancel",
    "backLink": "Go back",
    "employeeCaption": "Employee: {{name}}",
    "adminNote": "A reservoir admin has full access to every section — no individual permissions are set.",
    "selfNote": "You cannot change your own status or role."
  },
  "validation": {
    "required": "Fill in this field",
    "min": "Enter at least {{count}} characters",
    "max": "At most {{count}} characters",
    "login": "Latin letters, digits and . _ - only",
    "phone": "Invalid phone number",
    "fixErrors": "Fix the errors in the fields"
  },
  "toast": {
    "created": "Employee added",
    "createdElsewhere": "Employee added to “{{tenant}}”",
    "saved": "Saved",
    "noChanges": "No changes",
    "passwordChanged": "Password updated",
    "moved": "Employee moved to “{{tenant}}”",
    "blocked": "Employee blocked",
    "unblocked": "Employee unblocked",
    "deleted": "Employee deleted",
    "error": "Something went wrong",
    "copied": "Copied",
    "copyFailed": "Could not copy",
    "exported": "Logs exported",
    "nothingToExport": "No logs to export"
  },
  "dirty": {
    "title": "Unsaved changes",
    "text": "The entered data will be lost.",
    "stay": "Stay",
    "leave": "Leave"
  },
  "detail": {
    "label": "Employee details",
    "loading": "Loading...",
    "tabs": {
      "label": "Employee sections",
      "logs": "Logs",
      "info": "Details",
      "permissions": "Permissions"
    },
    "danger": "Danger zone",
    "block": "Block employee",
    "blockHint": "A blocked employee cannot sign in. Logs are kept.",
    "unblock": "Unblock",
    "blockedHint": "Blocked on {{date}}",
    "blockedByHint": "Blocked on {{date}} ({{name}})",
    "delete": "Delete employee",
    "deleteHint": "The employee is removed from the reservoir. Logs are kept.",
    "confirmBlock": {
      "title": "Block employee",
      "text": "“{{name}}” will not be able to sign in. Active sessions are closed.",
      "confirm": "Block"
    },
    "confirmUnblock": {
      "title": "Unblock",
      "text": "“{{name}}” will be able to sign in again.",
      "confirm": "Unblock"
    },
    "confirmDelete": {
      "title": "Delete employee",
      "text": "“{{name}}” will be removed from the reservoir. Logs are kept.",
      "confirm": "Delete"
    },
    "readOnly": "View mode — you have no right to change this.",
    "adminReadOnly": "Only admins can change a reservoir admin.",
    "notFound": "Employee not found",
    "notFoundHint": "The employee may have been deleted or moved to another reservoir."
  },
  "permissions": {
    "panels": {
      "admin": {
        "title": "Admin panel",
        "subtitle": "Management panel - CRUD rights"
      },
      "monitoring": {
        "title": "Monitoring panel",
        "subtitle": "Monitoring - viewing and file upload"
      }
    },
    "searchModules": "Search modules",
    "searchMenus": "Search menus",
    "selectAll": "Select all",
    "clearAll": "Clear all",
    "clearSearch": "Clear",
    "moduleCount": "{{count}} modules",
    "menuCount": "{{count}} menus",
    "results": "{{count}} results",
    "moreModules": "{{count}} more modules - find them by search",
    "moreMenus": "{{count}} more menus - find them by search",
    "noResults": "Nothing found",
    "notGrantable": "You do not have this right",
    "expand": "{{panel}} — expand",
    "collapse": "{{panel}} — collapse",
    "toggle": "{{panel}} — enable",
    "beyondCeiling": "This employee has rights you do not have — you cannot change them.",
    "modules": {
      "devices": "Devices",
      "device_categories": "Device categories",
      "device_config": "Device configuration",
      "employees": "Employees",
      "connectors": "Connectors",
      "device_locations": "Device locations",
      "device_info": "Device information",
      "device_calibration": "Device calibration"
    },
    "menus": {
      "dashboard": "Main panel",
      "device_config": "Device configuration",
      "device_categories": "Device categories",
      "documents": "Documents",
      "reports": "Reports",
      "sections": "Sections",
      "charts": "Charts"
    },
    "adminActions": {
      "create": "Create",
      "read": "Read",
      "update": "Edit",
      "delete": "Delete"
    },
    "monitoringActions": {
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "upload": "Upload files"
    }
  },
  "logs": {
    "search": "Search logs",
    "filtersLabel": "Log type",
    "filters": {
      "all": "All",
      "error": "Errors",
      "admin": "Admin panel",
      "monitoring": "Monitoring"
    },
    "range": "Period",
    "ranges": {
      "today": "Today",
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "90d": "Last 90 days",
      "all": "All time",
      "custom": "Custom range"
    },
    "customFrom": "From",
    "customTo": "To",
    "apply": "Apply",
    "today": "TODAY",
    "yesterday": "YESTERDAY",
    "entries": "{{count}} entries",
    "error": "Error",
    "export": "Export logs",
    "loadMore": "Load more",
    "empty": "No logs found",
    "emptyHint": "No entries in the selected period.",
    "loadError": "Could not load the logs",
    "showDetails": "Details",
    "panels": {
      "admin": "Admin panel",
      "monitoring": "Monitoring panel",
      "auth": "System"
    },
    "verbs": {
      "create": "Create",
      "update": "Edit",
      "delete": "Delete",
      "view": "View",
      "download": "Download",
      "upload": "File upload",
      "login": "Sign-in",
      "logout": "Sign-out",
      "password": "Password change",
      "block": "Block",
      "unblock": "Unblock",
      "ack": "Acknowledge",
      "other": "Action"
    },
    "gerunds": {
      "create": "create",
      "update": "edit",
      "delete": "delete",
      "view": "view",
      "download": "download",
      "upload": "upload a file",
      "login": "sign in",
      "logout": "sign out",
      "password": "change the password",
      "block": "block",
      "unblock": "unblock",
      "ack": "acknowledge",
      "other": "perform an action"
    },
    "sections": {
      "auth": "Authentication",
      "employees": "Employees",
      "devices": "Devices",
      "device_categories": "Device categories",
      "device_config": "Device configuration",
      "device_locations": "Device locations",
      "device_info": "Device information",
      "device_calibration": "Device calibration",
      "connectors": "Connectors",
      "dashboard": "Main panel",
      "sections": "Sections",
      "documents": "Documents",
      "reports": "Reports",
      "charts": "Charts",
      "alarm_settings": "Alarm settings",
      "system": "System"
    },
    "descriptions": {
      "deniedKeyword": "access denied",
      "denied": "{{section}}: tried to {{action}} - access denied",
      "denied_permission_escalation": "Tried to grant a right they do not have - access denied",
      "denied_role_not_assignable": "Tried to assign a role that is not allowed - access denied",
      "auth_login": "Signed in",
      "auth_logout": "Signed out",
      "auth_password_changed": "Changed the password",
      "member_created_named": "Added employee “{{name}}”",
      "member_updated_named": "Changed the details of “{{name}}”",
      "member_password": "Reset the password of “{{name}}”",
      "member_moved": "Moved “{{name}}” to “{{tenant}}”",
      "member_removed_named": "Deleted employee “{{name}}”",
      "member_blocked_named": "Blocked “{{name}}”",
      "member_unblocked_named": "Unblocked “{{name}}”",
      "document_created_named": "Uploaded the file “{{name}}”",
      "document_updated_named": "Edited the document “{{name}}”",
      "document_updated": "Edited a document",
      "document_deleted_named": "Deleted the document “{{name}}”",
      "document_viewed_named": "Opened the document “{{name}}”",
      "document_downloaded_named": "Downloaded the document “{{name}}”",
      "document_folder_created_named": "Created the folder “{{name}}”",
      "document_folder_updated": "Edited a folder",
      "document_folder_deleted_named": "Deleted the folder “{{name}}”",
      "dashboard_saved": "Saved the main panel",
      "section_created_named": "Created the section “{{name}}”",
      "section_deleted_named": "Deleted the section “{{name}}”",
      "folder_saved": "Saved a section drawing",
      "chart_created_named": "Created the chart “{{name}}”",
      "chart_updated": "Edited a chart",
      "chart_deleted_named": "Deleted the chart “{{name}}”",
      "device_created_named": "Created the device “{{name}}”",
      "device_deleted_named": "Deleted the device “{{name}}”",
      "device_category_created_named": "Created the category “{{name}}”",
      "device_location_created_named": "Created the location “{{name}}”",
      "alarm_acknowledged": "Acknowledged an alarm",
      "alarm_settings_updated": "Changed the alarm settings",
      "alarm_rule_updated": "Changed indicator thresholds",
      "tenant_created": "Created a reservoir",
      "tenant_updated": "Changed reservoir details",
      "tenant_deleted": "Deleted a reservoir",
      "organization_created": "Created an organization",
      "organization_updated": "Changed organization details",
      "organization_deleted": "Deleted an organization",
      "org_admin_created": "Added an organization admin",
      "org_admin_removed": "Removed an organization admin"
    },
    "generic": {
      "create": "Created a record",
      "create_named": "Created “{{name}}”",
      "update": "Changed data",
      "update_named": "Changed “{{name}}”",
      "delete": "Deleted a record",
      "delete_named": "Deleted “{{name}}”",
      "view": "Viewed",
      "view_named": "Opened “{{name}}”",
      "download": "Downloaded a file",
      "download_named": "Downloaded “{{name}}”",
      "upload": "Uploaded a file",
      "upload_named": "Uploaded the file “{{name}}”",
      "login": "Signed in",
      "login_named": "Signed in",
      "logout": "Signed out",
      "logout_named": "Signed out",
      "password": "Changed the password",
      "password_named": "Changed the password",
      "block": "Blocked an employee",
      "block_named": "Blocked “{{name}}”",
      "unblock": "Unblocked an employee",
      "unblock_named": "Unblocked “{{name}}”",
      "ack": "Acknowledged",
      "ack_named": "Acknowledged “{{name}}”",
      "other": "Action performed",
      "other_named": "“{{name}}”"
    },
    "details": {
      "name": "Name",
      "employee": "Employee",
      "role": "Role",
      "fields": "Changed",
      "movedTo": "New reservoir",
      "version": "Version",
      "indicator": "Indicator",
      "level": "Level",
      "request": "Request",
      "code": "Error code",
      "browser": "Browser",
      "ip": "IP address",
      "logId": "Log ID"
    },
    "fields": {
      "fullName": "Full name",
      "position": "Position",
      "phone": "Phone",
      "login": "Login",
      "isActive": "Active",
      "avatarFileId": "Photo",
      "role": "Role",
      "permissions": "Permissions",
      "tenantId": "Reservoir",
      "name": "Name"
    },
    "csv": {
      "logId": "Log ID",
      "date": "Date",
      "time": "Time",
      "title": "Action",
      "description": "Description",
      "panel": "Panel",
      "ip": "IP address",
      "browser": "Browser",
      "outcome": "Result",
      "ok": "Success",
      "failed": "Error"
    }
  }
}
